var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:([_vm.elementStyles, _vm.basicContentStyles])},[_c('eicon',{staticClass:"eicon-center text-white esign overlay",style:({'fontSize': Math.max(_vm.min_width_height/2, 20) + 'px'}),attrs:{"kind":"esign"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }